<template>
    <b-card>
        <b-card-body>
            <b-row class="mb-5">
                <b-col>
                    <h4>Conference Sessions</h4>
                </b-col>

                <b-col class="text-right">
                    <b-button variant="success" :to="{name: 'conf-session-new'}"><i class="fas fa-plus-circle mr-2"></i>New Session</b-button>
                </b-col>
            </b-row>

            <b-card class="conference mb-3" v-for="sess in conference.sessions">
                <b-row>
                    <b-col cols="7">
                        <h6 class="text-uppercase text-muted" style="font-size: 0.75rem;">{{sess.slot}}</h6>
                        <h6>{{sess.title}}</h6>
                        <div class="meta">Presented by <strong>{{sess.presenter}}</strong></div>
                        <div>{{sess.start_at | moment('MMMM Do YYYY, h:mm:ss a')}} - {{sess.end_at | moment('MMMM Do YYYY, h:mm:ss a')}}</div>
                    </b-col>
                    <b-col class="text-right">
                        <b-button variant="success" class="mr-2" :to="{name: 'conf-session', params: {id: conference.id, sessId: sess.id}}"><i class="fas fa-search mr-2"></i> Details</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "Sessions",
        data: function() {
            return {
            }
        },
        methods: {
            ...mapActions(['getConferenceById']),
        },
        computed: {
            ...mapGetters(['conference'])
        }
    }
</script>

<style scoped>

</style>
